import AudioRecorder from './AudioRecorderAndPlay';
export default AudioRecorder;
